import Vue from 'vue'
import axios from 'axios'
import { isBefore, isAfter, format, parse } from 'date-fns'
import { processAthlete } from '@/store/modules/athletes/detail'
import { processMatch } from '@/store/modules/matches/matchDetail'

export const ROUND_STATUSES = {
  closed: 'closed',
  live: 'live',
  upcoming: 'upcoming',
}

const calculateRoundStatus = (today, start, end) => {
  if (isBefore(today, start)) {
    return ROUND_STATUSES.upcoming
  }
  if (isAfter(today, start) && isBefore(today, end)) {
    return ROUND_STATUSES.live
  }
  return ROUND_STATUSES.closed
}

export const processRound = (round, now) => {
  const start = parse(round.start)
  const end = parse(round.end)

  if (!round.athletes && round.performances) {
    round.athletes = round.performances.map(({ athlete }) => processAthlete(athlete))
  } else {
    round.athletes = []
  }

  if (round.matches) {
    round.matches = round.matches.map((match) => processMatch(match, now))
  }

  const status = calculateRoundStatus(now, start, end)
  return {
    ...round,
    start,
    end,
    startFormatted: format(start, 'D.M.'),
    startDateTimeFormatted: format(start, 'D.M, hh:mma'),
    endFormatted: format(end, 'D.M.'),
    endDateTimeFormatted: format(end, 'D.M, hh:mma'),
    active: round.status,
    prizes: {
      first: round.prizes.find(({ position }) => position === 1),
      second: round.prizes.find(({ position }) => position === 2),
    },
    status,
  }
}

// state
export const state = {
  isRoundsLoading: false,
  selectedRoundId: false,
  rounds: [],
  roundsWithDetails: [],
  isRoundLoading: false,
}

// getters
export const getters = {
  getActiveRounds: ({ rounds }) => leagueType => rounds.filter(({ active, type }) => active === 1 && leagueType === type),
  getInactiveRounds: ({ rounds }) => leagueType => rounds.filter(({ active, type }) => active === 0 && leagueType === type),
  getRoundById: ({ roundsWithDetails }) => (roundId) => roundsWithDetails.find(({ id }) => id === parseInt(roundId)),
}
// mutations
export const mutations = {
  fetchRoundsStarted(state) {
    state.isRoundsLoading = true
  },
  fetchRoundsSuccess(state, { rounds, status, type }) {
    const today = new Date()
    const processedRounds = rounds.map(round => processRound(round, today))
    processedRounds.map((round) => {
      const index = state.rounds.findIndex(({ id }) => round.id === id)
      round.type = type
      if (index >= 0) {
        Vue.set(state.rounds, index, round)
      } else {
        state.rounds.push(round)
      }
    })
    state.isRoundsLoading = false
  },
  fetchRoundsFailed(state) {
    state.isRoundsLoading = false
  },

  fetchRoundByIdStarted(state) {
    state.isRoundLoading = true
  },
  fetchRoundByIdSuccess(state, { round }) {
    const today = new Date()
    const processedRound = processRound(round, today)
    const index = state.roundsWithDetails.findIndex(({ id }) => round.id === id)
    if (index >= 0) {
      Vue.set(state.roundsWithDetails, index, processedRound)
    } else {
      state.roundsWithDetails.push(processedRound)
    }
    state.isRoundLoading = false
  },
  fetchRoundByIdFailed(state) {
    state.isRoundLoading = false
  },
}
// actions
export const actions = {
  async fetchRounds({ commit }, { status, type }) {
    let rounds = null
    try {
      commit('fetchRoundsStarted')
      rounds = await axios.post(`rounds/${status}`, {
        type,
      })
      commit('fetchRoundsSuccess', { rounds, status, type })
    } catch (e) {
      commit('fetchRoundsFailed')
    }
    return rounds
  },
  async fetchRoundById({ commit }, { roundId }) {
    let round = null
    try {
      commit('fetchRoundByIdStarted')
      round = await axios.get(`round/${roundId}`)
      commit('fetchRoundByIdSuccess', { round })
    } catch (e) {
      commit('fetchRoundByIdFailed')
    }
    return processRound(round)
  },
}
